import {UserState} from "@/modules/user/types";
import {ActionTree, Module} from "vuex";
import {RootState} from "@/store/types";
import {getUsers} from "@/services/user";

const actions: ActionTree<UserState, RootState> = {
  async GET_USERS() {
    return await getUsers();
  }
}

export const user: Module<UserState, RootState> = {
  actions
}